module.exports = __webpack_public_path__ + "static/img/cjx08.f92d1ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cjx08.png
// module id = 165
// module chunks = 0